import { ITkInquiryTableListProps } from "./components/components";

const inquiryList: ITkInquiryTableListProps[][] = [
  [
    {
      title: "契約者番号",
      keyword: "contractorNo",
    },
    {
      title: "契約者名",
      keyword: "corpName",
    },
  ],
  [
    {
      title: "施設番号",
      keyword: "facilityNo",
    },
    {
      title: "施設名称",
      keyword: "facilityName",
    },
  ],
  [
    {
      title: "施設所在地",
      keyword: "address",
    },
  ],
  [
    {
      title: "掛金提出有無",
      keyword: "submitPaymentNotification",
    },
    {
      title: "ステータス",
      keyword: "status",
    },
  ],
  [
    {
      title: "施設種類",
      keyword: "facilityType",
    },
    {
      title: "施設区分",
      keyword: "facilityClassName",
    },
  ],
  [
    {
      title: "新設日",
      keyword: "requestDate",
    },
    {
      title: "新設受付日",
      keyword: "applyDate",
    },
  ],
  [
    {
      title: "特定職員数",
      keyword: "specificStaffNum",
    },
    {
      title: "措置入所障害児職員数",
      keyword: "hcStaffNum",
    },
  ],
  [
    {
      title: "入所定員数",
      keyword: "admissionCapacityNum",
    },
    {
      title: "職員配置基準数",
      keyword: "staffBaseNum",
    },
  ],
];

const commentHeader: any = [
  { headTitle: "当該施設に関するコメント", align: "left" },
];

const accordionContents: ITkInquiryTableListProps[][] = [
  [
    {
      title: "廃止日",
      keyword: "abolitionDate",
    },
    {
      title: "廃止受付日",
      keyword: "abolitionReceptionDate",
    },
  ],
  [
    {
      title: "休止日",
      keyword: "closedDate",
    },
    {
      title: "休止受付日",
      keyword: "closedReceptionDate",
    },
  ],
  [
    {
      title: "（部分）解除日",
      keyword: "calcelDate",
    },
    {
      title: "（部分）解除受付日",
      keyword: "cancelReceptionDate",
    },
  ],
  [
    {
      title: "（部分）解除・休止・廃止理由",
      keyword: "cancelReason",
    },
  ],
  [
    {
      title: "非加入有無",
      keyword: "notJoinAfterReformFlg",
    },
    {
      title: "非加入取下げ日",
      keyword: "notJoinAfterReformCancelDate",
    },
  ],
  [
    {
      title: "施設転換後非加入有無",
      keyword: "nonParticipationAfterFacilityConversion",
    },
    {
      title: "施設転換後非加入届取下げ日",
      keyword: "nonParticipationAfterFacilityConversionCancelDate",
    },
  ],
];

const staffInfoList: ITkInquiryTableListProps[][] = [
  [
    {
      title: "4/1職員数",
      keyword: "premiumStaffNum",
    },
  ],
  [
    {
      title: "現在職員数",
      keyword: "totalStaffNum",
    },
  ],
];

const headList: any = [
  { headTitle: "更新日時", align: "left" },
  { headTitle: "修正項目", align: "left" },
  { headTitle: "修正前", align: "left" },
  { headTitle: "修正後", align: "left" },
];

export {
  inquiryList,
  commentHeader,
  accordionContents,
  staffInfoList,
  headList,
};
